import React, { useCallback } from 'react';

import QuantityBox from 'modules/Common/QuantityBox';
import ShipperInfo from './sections/ShipperInfo';
import UserInfo from './sections/UserInfo';
import Header from './sections/Header';
import ShipperContacts from './sections/ShipperContacts';
import RecurringInfo from 'modules/shipper-order/detail/sections/recurring-info';
import { StyledCard, StyledCardHeader, StyledFlexParent, StyledPrice } from './styled';

import { useHistory } from 'react-router-dom';

const ShipperOrderCard = ({
  shipperOrder = {},
  load_types = [],
  showHeader = false,
  shipperOrdersSkin = {},
  showRemoveButton = false,
  withinGroupage = false,
  isFrozen,
  journeyId,
  journeyStatus,
  ...props
}) => {
  const history = useHistory();
  const { shipper, user } = shipperOrder;

  const handleViewOrder = useCallback(() => {
    history.push(`/view_shipper_order/${shipperOrder.id}`);
  }, [shipperOrder, history]);

  shipperOrder.load_types = load_types;

  return (
    <StyledCard {...props} data-testid="shiper-order-card">
      {showHeader && (
        <Header
          shipperOrder={shipperOrder}
          skin={shipperOrdersSkin}
          withinGroupage={withinGroupage}
          isFrozen={isFrozen}
          showRemoveButton={showRemoveButton}
          journeyId={journeyId}
          journeyStatus={journeyStatus}
        />
      )}
      {!!shipperOrder.recurring_order && (
        <StyledCardHeader pTop="XS" pBottom="XS" pLeft="S">
          <RecurringInfo item={shipperOrder} />
        </StyledCardHeader>
      )}
      <StyledFlexParent alignItems="stretch">
        <StyledPrice>
          <QuantityBox
            showPriceWithVat={false}
            is_frozen={isFrozen}
            quantityType="price"
            mRight="M"
            {...shipperOrder}
            openViewCost={handleViewOrder}
          />
        </StyledPrice>
        <ShipperInfo shipper={shipper} />
      </StyledFlexParent>
      <UserInfo shipper={shipper} user={user} />
      <ShipperContacts shipperId={shipper?.id} owner={user} contacts={shipper?.users} />
    </StyledCard>
  );
};

export default ShipperOrderCard;
